import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import {Record} from 'immutable';
import TrendHistoryActions from 'actions/inbox/TrendHistoryActions';

@immutableStore
class TrendHistoryStore {
  constructor() {
    this.state = Record({
      trendHistory: undefined,
      loading: undefined,
      success: undefined,
      error: undefined,
    })();
    this.bindActions(TrendHistoryActions);
  }

  fetchTrendHistory(ruleId, page, pageSize) {
    this.setState({
      trendHistory: undefined,
      loading: true,
      success: false,
      error: false,
    });
  }

  fetchTrendHistorySuccess(results) {
    this.setState({
      trendHistory: results,
      loading: false,
      success: true,
      error: false,
    });
  }

  fetchTrendHistoryError(e) {
    this.setState({
      trendHistory: undefined,
      loading: false,
      success: false,
      error: true,
    });
  }
}

export default alt.createStore(TrendHistoryStore);
